import http from '../utils/http';

const rootUrl = '/api';
const dentalxBaseUrl = '/dentalx/api';

const printApi = {
	/**
	 * 获取待打印列表
	 * @returns
	 */
	fetchPreprintList( params ) {
		return http.get( `${dentalxBaseUrl}/dentalxFetchPrintWaitingList`, params, { errCode: 'print' });
	},
	/**
	 * 基于来源导入待打印列表
	 * @returns
	 */
	addPreprintItemsBySource( data ) {
		return http.post( `${dentalxBaseUrl}/dentalxSourceImportPrintWaiting`, data, { errCode: 'print' });
	},
	/**
	 * 插入待打印列表项
	 * @returns
	 */
	addPreprintItems( data ) {
		return http.post( `${dentalxBaseUrl}/dentalxBatchImportPrintWaiting`, data, { errCode: 'print' });
	},
	/**
	 * 移除待打印列表项
	 * @returns
	 */
	deletePreprintItems( data ) {
		return http.post( `${dentalxBaseUrl}/dentalxBatchDelPrintWaiting`, data, { errCode: 'print' });
	},
	/**
	 * 云端切片功能授权
	 * @param {object} data
	 *
	 */
	slicePower( data ) {
		return http.post( `${rootUrl}/dlpSlicePower`, data, { errCode: 'print' });
	}

};
export default printApi;
